<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label" />
            <div class="dx-field-value">
                <dx-button text="Просмотр адреса по ЕГРЮЛ/ЕГРИП" @click="popupVisible = true" />
            </div>
        </div>
        <dx-popup
            :visible="popupVisible"
            :show-title="true"
            title="Адрес в ЕГРЮЛ"
            :drag-enabled="false"
            :hide-on-outside-click="true"
            :showCloseButton="true"
            @hidden="popupVisible = false"
        >

                <div class="egr-view-content">
                    <div class="egr-view-adm">
                        <div>Административно-территориальный формат</div>
                        <div class="egr-dx-field" >
                            <div class="egr-dx-field-label">Почтовый индекс</div>
                            <div class="egr-dx-field-value">
                                <dx-text-box :value="serverData['ac_postalcode']" :read-only="true" />
                            </div>
                        </div>
                        <div class="egr-dx-field" >
                            <div class="egr-dx-field-label">Код субъекта РФ, который является учредителем ЮЛ</div>
                            <div class="egr-dx-field-value">
                                <dx-text-box :value="serverData['ac_regioncode']" :read-only="true" />
                            </div>
                        </div>
                        <div class="egr-dx-field" >
                            <div class="egr-dx-field-label">Тип элемента регион (республика, край и т.п.)</div>
                            <div class="egr-dx-field-value">
                                <dx-text-box :value="serverData['ac_region_type']" :read-only="true" />
                            </div>
                        </div>
                        <div class="egr-dx-field" >
                            <div class="egr-dx-field-label">Наименование (элемент регион)</div>
                            <div class="egr-dx-field-value">
                                <dx-text-box :value="serverData['ac_region_name']" :read-only="true" />
                            </div>
                        </div>
                        <div class="egr-dx-field" >
                            <div class="egr-dx-field-label">Тип элемента район (район, улус и т.п.)</div>
                            <div class="egr-dx-field-value">
                                <dx-text-box :value="serverData['ac_district_type']" :read-only="true" />
                            </div>
                        </div>
                        <div class="egr-dx-field" >
                            <div class="egr-dx-field-label">Наименование (элемент район)</div>
                            <div class="egr-dx-field-value">
                                <dx-text-box :value="serverData['ac_district_name']" :read-only="true" />
                            </div>
                        </div>
                        <div class="egr-dx-field" >
                            <div class="egr-dx-field-label">Тип элемента город (город, волость и т.п.)</div>
                            <div class="egr-dx-field-value">
                                <dx-text-box :value="serverData['ac_city_type']" :read-only="true" />
                            </div>
                        </div>
                        <div class="egr-dx-field" >
                            <div class="egr-dx-field-label">Наименование (элемент город)</div>
                            <div class="egr-dx-field-value">
                                <dx-text-box :value="serverData['ac_city_name']" :read-only="true" />
                            </div>
                        </div>
                        <div class="egr-dx-field" >
                            <div class="egr-dx-field-label">Тип элемента населённый пункт (посёлок, село и т.п.)</div>
                            <div class="egr-dx-field-value">
                                <dx-text-box :value="serverData['ac_place_type']" :read-only="true" />
                            </div>
                        </div>
                        <div class="egr-dx-field" >
                            <div class="egr-dx-field-label">Наименование (элемент населённый пункт)</div>
                            <div class="egr-dx-field-value">
                                <dx-text-box :value="serverData['ac_place_name']" :read-only="true" />
                            </div>
                        </div>
                        <div class="egr-dx-field" >
                            <div class="egr-dx-field-label">Тип адресного объекта улица (улица, проспект, переулок и т.п.)</div>
                            <div class="egr-dx-field-value">
                                <dx-text-box :value="serverData['ac_street_type']" :read-only="true" />
                            </div>
                        </div>
                        <div class="egr-dx-field" >
                            <div class="egr-dx-field-label">Наименование (элемент улица)</div>
                            <div class="egr-dx-field-value">
                                <dx-text-box :value="serverData['ac_street_name']" :read-only="true" />
                            </div>
                        </div>
                        <div class="egr-dx-field" >
                            <div class="egr-dx-field-label">Дом (владение и т.п.)</div>
                            <div class="egr-dx-field-value">
                                <dx-text-box :value="serverData['ac_house']" :read-only="true" />
                            </div>
                        </div>
                        <div class="egr-dx-field" >
                            <div class="egr-dx-field-label">Корпус (строение и т.п.)</div>
                            <div class="egr-dx-field-value">
                                <dx-text-box :value="serverData['ac_building']" :read-only="true" />
                            </div>
                        </div>
                        <div class="egr-dx-field" >
                            <div class="egr-dx-field-label">Квартира (офис и т.п.)</div>
                            <div class="egr-dx-field-value">
                                <dx-text-box :value="serverData['ac_flat']" :read-only="true" />
                            </div>
                        </div>
                    </div>
                    <div class="egr-view-mun">
                        <div>Муниципальный формат</div>

                    <div class="egr-dx-field" >
                        <div class="egr-dx-field-label">Почтовый индекс</div>
                        <div class="egr-dx-field-value">
                            <dx-text-box :value="serverData['acm_postalcode']" :read-only="true" />
                        </div>
                    </div>
                    <div class="egr-dx-field" >
                        <div class="egr-dx-field-label">Наименование субъекта Российской Федерации</div>
                        <div class="egr-dx-field-value">
                            <dx-text-box :value="serverData['acm_region_name']" :read-only="true" />
                        </div>
                    </div>

                    <div class="egr-dx-field" >
                        <div class="egr-dx-field-label">Муниципальный район/ городской округ/ внутригородская территория города федерального значения</div>
                        <div class="egr-dx-field2-value">
                            <div class="egr-dx-short-field-value"><dx-text-box :value="serverData['acm_distr_city_type']" :read-only="true"/></div>
                            <div class="egr-dx-short-field-value"><dx-text-box :value="serverData['acm_distr_city_name']" :read-only="true"/></div>
                        </div>
                    </div>
                    <div class="egr-dx-field" >
                        <div class="egr-dx-field-label">Городское поселение / сельское поселение / внутригородской район городского округа</div>
                        <div class="egr-dx-field2-value">
                            <div class="egr-dx-short-field-value"><dx-text-box :value="serverData['acm_place_type']" :read-only="true"/></div>
                            <div class="egr-dx-short-field-value"><dx-text-box :value="serverData['acm_place_name']" :read-only="true"/></div>
                        </div>
                    </div>
                    <div class="egr-dx-field" >
                        <div class="egr-dx-field-label">Населенный пункт (город, деревня, село и прочее)</div>
                        <div class="egr-dx-field2-value">
                            <div class="egr-dx-short-field-value"><dx-text-box :value="serverData['acm_locality_type']" :read-only="true"/></div>
                            <div class="egr-dx-short-field-value"><dx-text-box :value="serverData['acm_locality_name']" :read-only="true"/></div>
                        </div>
                    </div>
                    <div class="egr-dx-field" >
                        <div class="egr-dx-field-label">Элемент планировочной структуры</div>
                        <div class="egr-dx-field2-value">
                            <div class="egr-dx-short-field-value"><dx-text-box :value="serverData['acm_plan_type']" :read-only="true"/></div>
                            <div class="egr-dx-short-field-value"><dx-text-box :value="serverData['acm_plan_name']" :read-only="true"/></div>
                        </div>
                    </div>
                    <div class="egr-dx-field" >
                        <div class="egr-dx-field-label">Элемент улично-дорожной сети</div>
                        <div class="egr-dx-field2-value">
                            <div class="egr-dx-short-field-value"><dx-text-box :value="serverData['acm_street_type']" :read-only="true"/></div>
                            <div class="egr-dx-short-field-value"><dx-text-box :value="serverData['acm_street_name']" :read-only="true"/></div>
                        </div>
                    </div>
                    <div class="egr-dx-field" >
                        <div class="egr-dx-field-label">Здание / сооружение</div>
                        <div class="egr-dx-field-value">
                            <dx-text-box :value="serverData['acm_house']" :read-only="true" />
                        </div>
                    </div>
                    <div class="egr-dx-field" >
                        <div class="egr-dx-field-label">Помещение в пределах здания, сооружения</div>
                        <div class="egr-dx-field-value">
                            <dx-text-box :value="serverData['acm_flat']" :read-only="true" />
                        </div>
                    </div>
                    <div class="egr-dx-field" >
                        <div class="egr-dx-field-label">Помещение в пределах квартиры</div>
                        <div class="egr-dx-field-value">
                            <dx-text-box :value="serverData['acm_room']" :read-only="true" />
                        </div>
                    </div>



                    </div>

                </div>

        </dx-popup>
    </div>
</template>

<script setup>
import { DxButton, DxPopup, DxTextBox } from 'devextreme-vue';
import { ref } from 'vue';

defineProps({
    serverData: {
        type: Object,
        default: () => {},
    },
});

const popupVisible = ref(false);
</script>

<style>
.egr-view-content {
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
    padding: 5px 5px 0 5px;
}

.egr-view-adm {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex-basis: 50%;
    padding: 5px 5px 0 5px;
}

.egr-view-mun {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex-basis: 50%;
    padding: 5px 5px 0 5px;
}

.egr-dx-field {
    display: flex;
    flex-direction: column;
}

.egr-dx-field-label {
    display: flex;
    flex-grow: 1;
    align-self: start;
    font-size: 0.9rem;
    min-height: 1rem;
    width: 100%;
}

.egr-dx-field-value {
    width: 100%;
}

.egr-dx-field2-value {
    width: 100%;
    display: flex;
    flex-direction: row;
}

.egr-dx-short-field-value {
    flex-basis: 50%;
    padding-right: 10px;
}


</style>
